import * as AdminComponents from "app/adminApp/components";
import * as Components from "app/components";

import { Button, Icon, Text } from "app/components";
import { colors, spacing } from "app/utils/theme";
import { get, startCase } from "lodash";

import styled from "styled-components";

const DataGrid = ({ data }) => {
  const columns = get(data, "columns", []);
  const rows = get(data, "value", []);

  const addRow = () => {
    data.onChange([...rows, get(data, "newObject", {})]);
  };

  const updateRow = (index, k, v) => {
    data.onChange(
      rows.map((r, i) => {
        if (i === index) {
          return { ...r, [k]: v };
        }
        return r;
      })
    );
  };

  // Make this toggle-able?
  const showDelete = true;

  return (
    <>
      <TableBorderContainer>
        <TableContainer>
          {columns.map((column) => {
            const FormInput = get(
              { ...Components, ...AdminComponents },
              column.componentId
            );

            return (
              <Column width={column.width}>
                <TableHeader>
                  <Text
                    data={{
                      text: startCase(column.label || column.key),
                      fontStyle: "headingXs",
                      cursor: "pointer",
                    }}
                  />
                </TableHeader>
                {rows.map((row, rowIndex) => {
                  const disabled =
                    row.disabled ||
                    get(column, "disableOperators", []).includes(
                      get(row, "operator")
                    );

                  return (
                    <CellContainer>
                      <FormInput
                        data={{
                          ...column,
                          excludedSources: get(data, "excludedSources", []),
                          dynamicSources: get(data, "dynamicSources", []),
                          previousSteps: get(data, "previousSteps"),
                          value: get(row, column.key),
                          border: "0px",
                          disabled,
                          padding:
                            column.componentId === "Select"
                              ? "0px 0px 0px 6px"
                              : spacing.s2,
                          onChange: (v) => updateRow(rowIndex, column.key, v),
                        }}
                      />
                    </CellContainer>
                  );
                })}
              </Column>
            );
          })}

          {showDelete && rows.length > 0 && (
            <DeleteColumn>
              <TableHeader></TableHeader>
              {rows.map((row, rowIndex) => (
                <CellContainer style={{ padding: "5px" }}>
                  <Icon
                    data={{
                      icon: "FiTrash",
                      hover: true,
                      onClick: () =>
                        data.onChange(rows.filter((r, ri) => rowIndex !== ri)),
                      color: "var(--grey7)",
                      size: 18,
                    }}
                  />
                </CellContainer>
              ))}
            </DeleteColumn>
          )}
        </TableContainer>

        {rows.length === 0 && (
          <Text
            data={{
              text: "No Data",
              fontStyle: "bodySm",
              cursor: "pointer",
              padding: "8px 5px 8px 8px",
            }}
          />
        )}
      </TableBorderContainer>

      <Button
        data={{
          text: "Add",
          onClick: addRow,
          size: "small",
          type: "basic",
          icon: "FiPlus",
          margin: "5px 0 0 0",
        }}
      />
    </>
  );
};

export default DataGrid;

const TableBorderContainer = styled.div`
  border: 1px solid var(--grey21);
  border-radius: 10px;
  overflow: hidden;
`;

const TableContainer = styled.div`
  display: flex;
`;

const DeleteColumn = styled.div`
  width: 30px;
  :not(:last-child) {
    border-right: 1px solid var(--grey21);
  }
`;

const Column = styled.div`
  width: ${(p) => p.width || "100px"};
  flex: 1;
  :not(:last-child) {
    border-right: 1px solid var(--grey21);
  }
`;

const CellContainer = styled.div`
  height: 34px;
  display: flex;
  align-items: center;
  overflow: hidden;
  :not(:last-child) {
    border-bottom: 1px solid var(--grey21);
  }
`;

const TableHeader = styled.div`
  font-weight: 600;
  font-size: 12px;
  height: 34px;
  display: flex;
  align-items: center;
  padding: 5px 5px 5px 8px;
  border-bottom: 1px solid var(--grey21);
`;
